
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 9 7\" id=\"arrow_jax_4be1be27040983052c63e22ed424aac7\" > <path d=\"M4.79743 6.08105L8.30131 1.73488C8.61773 1.34239 8.33836 0.758302 7.8342 0.758302H0.826443C0.322287 0.758302 0.0429123 1.34239 0.359337 1.73488L3.86322 6.08105C4.10338 6.37895 4.55727 6.37895 4.79743 6.08105Z\" fill=\"#697487\"/> </symbol>";
module.exports = sprite.add(image, "arrow_jax_4be1be27040983052c63e22ed424aac7");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 1744
// module chunks = 1